import Vue from 'vue'
import Router from 'vue-router'
import HeaderMainLayout from '@/layouts/HeaderMainLayout'
import Account from './views/personal-center/components/account-settings'
import Infomation from './views/personal-center/components/login-information'
import myDevice from './views/personal-center/components/my-device.vue'
import WaySelect from './views/modify-tel/components/way-select'
import emailAuthentication from './views/modify-tel/components/email-authentication'
import telAuthentication from './views/modify-tel/components/tel-authentication'
import telBind from './views/modify-tel/components/tel-bind'
import modifySuccess from './views/modify-tel/components/modify-success'
import jobCard from './views/personal-center/components/job-card'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HeaderMainLayout,
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "home" */ './views/home')
        }
      ]
    },
    {
      path: '/modifyTel',
      name: 'modifyTel',
      component: HeaderMainLayout,
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "modifyTel" */ './views/modify-tel'),
          children: [
            {
              path: '',
              component: WaySelect
            },
            {
              path: 'email-authentication',
              component: emailAuthentication
            },
            {
              path: 'tel-authentication',
              component: telAuthentication
            },
            {
              path: 'tel-bind',
              component: telBind
            },
            {
              path: 'success',
              component: modifySuccess
            }
          ]
        }
      ]
    },
    {
      path: '/personal',
      name: 'personal',
      component: HeaderMainLayout,
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "personal" */ './views/personal-center'),
          children: [
            {
              path: 'account',
              component: Account
            },
            {
              path: '',
              redirect: 'account'
            },
            {
              path: 'loginInfomation',
              component: Infomation
            },
            {
              path: 'myDevice',
              component: myDevice
            },
            {
              path: 'jobCard',
              component: jobCard
            }
          ]
        }
      ]
    },
    {
      path: '/search-result/:key',
      component: HeaderMainLayout,
      children: [
        {
          path: '',
          name: 'search-result',
          component: () => import(/* webpackChunkName: "search-result" */ './views/search-result')
        }
      ]
    },
    {
      path: '/result-more/:key/:type',
      component: HeaderMainLayout,
      children: [
        {
          path: '',
          name: 'result-more',
          component: () => import(/* webpackChunkName: "search-result" */ './views/search-result')
        }
      ]
    },
    {
      path: '/passport',
      component: HeaderMainLayout,
      children: [
        {
          path: '',
          name: 'passport',
          component: () => import(/* webpackChunkName: "passport" */ './views/passport')
        }
      ]
    },
    {
      path: '/product-dynamic',
      component: HeaderMainLayout,
      children: [
        {
          path: '',
          name: 'product-dynamic',
          component: () => import(/* webpackChunkName: "product-dynamic" */ './views/product-dynamic')
        }
      ]
    },
    {
      path: '/HeadquartersMap',
      name: 'HeadquartersMap',
      component: HeaderMainLayout,
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "HeadquartersMap" */ './views/HeadquartersMap')
        }
      ]
    },
    {
      path: '/link',
      name: 'link',
      component: () => import(/* webpackChunkName: "link" */ './views/link')
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
